import type { AxiosInstance } from 'axios';

export function applyRequestLoggingInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use((config) => {
    const method = config.method?.toUpperCase() ?? '???';
    const url = config.url ?? '???';
    config.headers.set('X-Request-Start', Date.now().toString());
    console.log(`[API] → ${method} ${url}`);
    return config;
  });

  client.interceptors.response.use(
    (response) => {
      const start = response.config.headers?.['X-Request-Start'];
      const method = response.config.method?.toUpperCase() ?? '???';
      const url = response.config.url ?? '???';
      const duration = start ? Date.now() - Number(start) : -1;
      console.log(`[API] ← ${method} ${url} ${response.status} ${duration}ms`);
      return response;
    },
    (error) => {
      if (error.config) {
        const start = error.config.headers?.['X-Request-Start'];
        const method = error.config.method?.toUpperCase() ?? '???';
        const url = error.config.url ?? '???';
        const duration = start ? Date.now() - Number(start) : -1;
        const status = error.response?.status ?? 'ERR';
        console.log(`[API] ← ${method} ${url} ${status} ${duration}ms`);
      }
      return Promise.reject(error);
    },
  );
}
